// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PKgF","top":"styles_top___y4HT","left":"styles_left__1mIFH","description":"styles_description__3f5-k"};